package fr.frux.feature.map.site

import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import fr.frux.core.designsystem.components.SnackbarMessageEffect
import fr.frux.feature.map.resources.Res
import fr.frux.feature.map.resources.map_confirmation_view
import fr.frux.feature.map.resources.map_site_created
import fr.frux.feature.map.resources.map_site_removed
import org.jetbrains.compose.resources.stringResource

/**
 * Avis de la couche lieux (creation, suppression), portes par l'etat et montres par la meme
 * snackbar que les autres avis de la carte. Les libelles sont resolus ici, en composition :
 * `stringResource` est asynchrone sur js (#438).
 */
@Composable
internal fun SiteNoticeEffects(
    sites: SiteLayerViewModel,
    snackbarHostState: SnackbarHostState,
    onSiteClick: (Long) -> Unit,
) {
    val notice =
        sites.state
            .collectAsState()
            .value.notice
    val created = stringResource(Res.string.map_site_created)
    val removed = stringResource(Res.string.map_site_removed)
    val viewLabel = stringResource(Res.string.map_confirmation_view)
    val createdId = (notice as? SiteNotice.Created)?.siteId
    SnackbarMessageEffect(
        trigger = notice,
        message =
            when (notice) {
                is SiteNotice.Created -> created
                SiteNotice.Removed -> removed
                null -> null
            },
        snackbarHostState = snackbarHostState,
        actionLabel = viewLabel.takeIf { createdId != null },
        duration = SnackbarDuration.Long,
    ) { result ->
        if (result == SnackbarResult.ActionPerformed && createdId != null) onSiteClick(createdId)
        sites.consumeNotice()
    }
}
